import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractComponent } from '@spike/scaffolds';
import { TableModule } from 'primeng/table';
import { Tag } from 'primeng/tag';
import { InvestmentRecap } from '../../models/investment-recap.model';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-investments-table',
  standalone: true,
  imports: [
    CommonModule, 
    TableModule, 
    Tag
  ],
  templateUrl: './investments-table.html'
})
export class InvestmentsTableComponent extends AbstractComponent {
  items = input.required<InvestmentRecap[]>();
  onSelect = output<InvestmentRecap>();
  

  orderedList= computed(()=>{
    const items = this.items();
    return items.sort((x1: InvestmentRecap, x2: InvestmentRecap) => (new Date(x1.finIsinId).getTime()) - new Date(x2.finIsinId).getTime());
  });
  
}